<template>
  <div class="flex items-start">
    <div class="flex-shrink-0 px-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="w-5 h-5 handle cursor-move text-gray-400 hover:text-black"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <circle cx="9" cy="5" r="1" />
        <circle cx="9" cy="12" r="1" />
        <circle cx="9" cy="19" r="1" />
        <circle cx="15" cy="5" r="1" />
        <circle cx="15" cy="12" r="1" />
        <circle cx="15" cy="19" r="1" />
      </svg>
    </div>
    <div class="flex-1">
      <div class="flex items-start">
        <div class="px-4">
          <p class="text-sm font-medium text-gray-900">
            {{ funnelStage.name }}
          </p>
          <p class="text-sm text-gray-500">
            {{ funnelStage.description }}
          </p>
          <ul class="mt-4 list-disc text-xs text-gray-500">
            <li v-for="audience in funnelStage.audiences" :key="audience.id">
              {{ audience.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="!disabled" class="flex-shrink-0">
      <div class="flex items-center space-x-2">
        <FunnelStageEditAction :funnel-stage="funnelStage" @updated="handleUpdated" />
        <FunnelStageDeleteAction :funnel-stage-id="funnelStage.id" @deleted="handleDeleted" />
      </div>
    </div>
  </div>
</template>

<script>
import FunnelStageEditAction from './FunnelStageEditAction.vue';
import FunnelStageDeleteAction from './FunnelStageDeleteAction.vue';

export default {
  components: { FunnelStageEditAction, FunnelStageDeleteAction },
  props: {
    funnelStage: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  methods: {
    handleDeleted() {
      this.$emit('deleted');
    },
    handleUpdated() {
      this.$emit('updated');
    },
  },
};
</script>
